import React from 'react';

const MemberIcon = ({ width, height }: { width: number; height: number }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 34 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='false'
    aria-label='Members-only event'
  >
    <path
      d='M25.513 5.38497L23.3781 6.75694C21.969 7.66287 20.0888 6.88432 19.7324 5.24734L19.1936 2.76796C18.6815 0.41076 15.3184 0.410706 14.8064 2.76796L14.2676 5.24706C13.9114 6.88424 12.0311 7.66292 10.6219 6.75694L8.48699 5.38497C6.45805 4.08042 4.08053 6.45784 5.38485 8.4868L6.75685 10.6217C7.66283 12.0309 6.88424 13.9114 5.24707 14.2676L2.76796 14.8064C0.410789 15.3185 0.410785 18.6815 2.76796 19.1936L5.24734 19.7324C6.88432 20.0888 7.66287 21.969 6.75694 23.3781L5.38497 25.513C4.08065 27.542 6.45806 29.9196 8.48699 28.615L10.6217 27.2431C12.0309 26.3371 13.9114 27.1158 14.2676 28.7529L14.8064 31.232C15.3184 33.5893 18.6815 33.5892 19.1936 31.232L19.7324 28.7527C20.0888 27.1157 21.969 26.3371 23.3781 27.2431L25.513 28.615C27.542 29.9196 29.9196 27.542 28.615 25.513L27.2431 23.3783C26.3371 21.9692 27.1159 20.0888 28.7529 19.7324L31.2321 19.1936C33.5893 18.6815 33.5893 15.3184 31.232 14.8064L28.7529 14.2676C27.1158 13.9114 26.3371 12.0309 27.2431 10.6217L28.6152 8.4868C29.9194 6.4579 27.5419 4.08069 25.513 5.38497Z'
      fill='#3986c7'
      stroke='#F6F5F1'
      strokeWidth='2'
    />
  </svg>
);

export default MemberIcon;
